import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

/**
 * Check if the product is eligible for showing the points section in JPP
 */
export function shouldShowPointsSection(
  selectedOffer: NonNullable<GetPickersResponse['selectedOffer']>,
  product: GetProductResponse,
): boolean {
  return Boolean(selectedOffer.discount) && Boolean(product.priceWhenNew)
}
